import { MasterDataEntityPage } from "../MasterDataEntityPage"
import { MasterDataPanelLayout } from "../MasterDataPanelLayout"
import { SupplierDetailPanel } from "../suppliers/SupplierDetailPanel"
import { SupplierListPanel } from "../suppliers/SupplierListPanel"
import { useRowMultiSelect } from "../useRowMultiSelect"

export function SuppliersPage() {
  const { selectedIds, toggleSelected, removeIds } = useRowMultiSelect()

  return (
    <MasterDataEntityPage
      titleKey="MC_MD_TAB_SUPPLIERS"
      helpArticleId="master-data.suppliers"
    >
      <MasterDataPanelLayout
        listPanel={
          <SupplierListPanel
            selectedIds={selectedIds}
            onToggleSelected={toggleSelected}
          />
        }
        detailPanel={
          <SupplierDetailPanel
            selectedIds={selectedIds}
            onRemoveIds={removeIds}
          />
        }
      />
    </MasterDataEntityPage>
  )
}
